<template>
  <div>

    <food-editor 
      :show="showFoodEditor" 
      :item-id="editIngredientId"
      @on-close="showFoodEditor = false"
      @on-new="updateFood($event, true)"
      @on-update="updateFood($event)"
    />

    <div class="text-center" v-if="canCreate" style="position: relative;">
      <v-fade-transition mode="out-in" appear>
        <div style="position: absolute; top: 0; right: 0;" v-if="isAdmin && numberOfRequests">
          <v-btn color="dflOrange" small dark :to="{name: 'food-search-requests'}">View Requests ({{ numberOfRequests }})</v-btn>
        </div>
      </v-fade-transition>

      <v-btn @click="openEditor()">Create</v-btn>
    </div>

    <v-data-table

      :headers="headers"
      :items="food"
      :loading="loading"

      :options.sync="options"
      :server-items-length="totalFood"

      :footer-props="{
        itemsPerPageOptions: [12,24,48,-1]
      }"
      @click:row="openEditor($event.id)"
    >
      <template v-slot:item.is_beverage="{item}">
        <v-tooltip top>
          <template v-slot:activator="{on}">
            <v-icon v-on="on" v-text="'mdi-' + (item.is_beverage ? 'coffee' : 'food-apple')"></v-icon>
          </template>
          <span>{{ (item.is_beverage ? 'Beverage' : 'Food' ) }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.image="{item}">
        <v-img
          v-if="item.image"
          :src="item.image.url_path"
          contain
          style="width: 80px; max-width: 80px; max-height: 45px; height: 45px;"
        />
      </template>
      <template v-slot:item.name="{item}">
        {{ item.name }} <div class="grey--text overline float-right"> {{ item.category.name }}</div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import FoodEditor from './FoodEditor'

export default {
  name: 'FoodBrowser',
  components: {
    'food-editor': FoodEditor
  },
  data: () => ({
    loading: true,
    showFoodEditor: false,
    editIngredientId: null,
    numberOfRequests: 0,
    headers: [
      {
        text: 'ID',
        align: 'center',
        sortable: false,
        value: 'id',
        width: '50px'
      },
      {
        text: '',
        align: 'center',
        sortable: false,
        value: 'is_beverage',
        width: '50px'
      },
      {
        text: 'Name',
        align: 'start',
        value: 'name',
      },
      {
        text: 'Image',
        value: 'image',
        sortable: false,
        width: '80px'
      }
    ],
    food: [],
    options: {
      itemsPerPage: 12,
      sortBy: [
        'name'
      ],
      sortDesc: [
        false
      ]
    },
    totalFood: 0
  }),
  mounted: function() {
    this.getDataFromApi();
    if(this.isAdmin) {
      this.getRequestTotals();
    }
  },
  watch: {
    options: {
      handler: function() {
        this.getDataFromApi();
      },
      deep: true
    },
    
  },
  computed: {
    canCreate: function() {
      return this.$store.getters.userCan('sh_ingredient_c');
    },
    isAdmin: function() {
      return this.$store.getters.userIs('food-search-admin');
    }
  },
  methods: {
    getDataFromApi: function() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      let qParams = [];

      this.loading = true;
      qParams.push('expand=preparations');
      qParams.push('sort=' + (sortDesc[0] ? '-' : '') + sortBy[0]);
      qParams.push('per-page=' + itemsPerPage);
      qParams.push('page=' + page);
      
      this.$http.get('ingredients?' + qParams.join('&'))
        .then(response => {
          this.food = response.data.items;
          this.totalFood = response.data._meta.totalCount;
        })
        .catch(err => {
          if(err.response.status == 401) return;

          this.$swal.fire('Error', 'There was an error loading the food', 'error');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getRequestTotals: function() {
      this.$http.get('ingredient-requests/total')
        .then(response => {
          this.numberOfRequests = parseInt(response.data.open);
        })
        .catch(err => {
          console.log(err);
          if(err.response.status == 401) return;

          this.$swal.fire('Error', 'There was an error checking ingredient request totals', 'error');
        })
    },
    openEditor: function(id) {
      this.editIngredientId = (!id ? null : id);
      this.showFoodEditor = true;
    },
    updateFood: function(item, isNew) {
      if(isNew) {
        this.food.unshift(item);
        this.totalFood++;
      } else {
        for(let i = 0; i < this.food.length; i++) {
          if(this.food[i].id == item.id) this.$set(this.food, i, item);
        }
      }
    }
  }
}
</script>